module.exports = __webpack_public_path__ + "4309f24e790cd0667993403d7637f3a2.svg";